import { Link } from 'components/link/Link';
import style from './backToProjects.module.scss';

const BackToProjects = () => {
  return (
    <Link href="/">
      <a className={style.backButton}>
        <span className={style.backButtonLine} />
        <span className={style.backButtonLine} />
        <span className={style.backButtonLine} />
        <span className={style.backButtonText}>All Work</span>
      </a>
    </Link>
  );
};

export default BackToProjects;
